import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 21,
	viewBox: "0 0 26 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "family_home",
		d: "M12.9999 0.97168L25.176 10.0914L24.3836 11.0987L21.8997 9.23575V20.9717H4.10012V9.23575L1.61613 11.0987L0.82373 10.0914L12.9999 0.97168ZM8.55477 11.3958C8.55477 12.246 9.01205 13.1519 9.9266 14.1135C10.8409 15.0753 11.8654 16.0736 12.9999 17.1085C14.167 16.0736 15.2078 15.0759 16.1221 14.1154C17.0365 13.155 17.4936 12.2506 17.4936 11.4022C17.4936 10.6979 17.2523 10.1118 16.7696 9.64418C16.2867 9.17631 15.7071 8.94237 15.0309 8.94237C14.6124 8.94237 14.2325 9.02915 13.8911 9.20269C13.5495 9.37624 13.2525 9.59428 12.9999 9.85682C12.7799 9.59428 12.4926 9.37624 12.1379 9.20269C11.7834 9.02915 11.4124 8.94237 11.0251 8.94237C10.347 8.94237 9.76577 9.17493 9.28137 9.64005C8.79697 10.105 8.55477 10.6902 8.55477 11.3958ZM20.6283 19.7003V8.25773L12.9999 2.53645L5.37151 8.25773V19.7003H20.6283Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: 1
		}
	})
});
export default SvgHome;
